"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Grid_st_css_1 = require("./Grid.st.css");
var GridUtils_1 = require("./GridUtils");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var constants_1 = require("./constants");
var DataHooks_1 = require("./DataHooks");
var Item_1 = require("./Item/Item");
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Grid.prototype.getContainerDataAttributes = function (_a) {
        var _b;
        var itemsPerRow = _a.itemsPerRow, itemMaxWidth = _a.itemMaxWidth, dividerWidth = _a.dividerWidth, rowGapInPixels = _a.rowGapInPixels, columnGapInPixels = _a.columnGapInPixels, maxColumnWidth = _a.maxColumnWidth, minColumnWidth = _a.minColumnWidth;
        return _b = {},
            _b[DataHooks_1.GridDataKeys.itemsPerRow] = itemsPerRow,
            _b[DataHooks_1.GridDataKeys.itemMaxWidth] = itemMaxWidth,
            _b[DataHooks_1.GridDataKeys.dividerWidth] = dividerWidth,
            _b[DataHooks_1.GridDataKeys.rowGap] = rowGapInPixels,
            _b[DataHooks_1.GridDataKeys.columnGap] = columnGapInPixels,
            _b[DataHooks_1.GridDataKeys.maxColumnWidth] = maxColumnWidth,
            _b[DataHooks_1.GridDataKeys.minColumnWidth] = minColumnWidth,
            _b;
    };
    Grid.prototype.render = function () {
        var _this = this;
        return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var mobile = _a.mobile;
            var _b = _this.props, showRowDivider = _b.showRowDivider, width = _b.width, children = _b.children, uniformRowHeight = _b.uniformRowHeight, minColumnWidth = _b.minColumnWidth, maxColumns = _b.maxColumns, rest = __rest(_b, ["showRowDivider", "width", "children", "uniformRowHeight", "minColumnWidth", "maxColumns"]);
            var itemMinWidth = minColumnWidth + "px";
            var itemMaxWidth = _this.props.maxColumnWidth
                ? _this.props.maxColumnWidth + "px"
                : '100vw';
            var rowGap = typeof _this.props.rowGap === 'number'
                ? _this.props.rowGap
                : mobile
                    ? constants_1.MOBILE_ROW_GAP
                    : constants_1.ROW_GAP;
            var columnGap = typeof _this.props.columnGap === 'number'
                ? _this.props.columnGap
                : mobile
                    ? constants_1.MOBILE_COLUMN_GAP
                    : constants_1.COLUMN_GAP;
            var dividerWidth = typeof _this.props.dividerWidth === 'number'
                ? _this.props.dividerWidth + "px"
                : _this.props.dividerWidth;
            var rowGapInPixels = showRowDivider
                ? "calc(" + rowGap + "px + " + dividerWidth + ")"
                : rowGap + "px";
            var columnGapInPixels = columnGap + "px";
            var isFullWidth = width === 0;
            var itemsPerRow = isFullWidth
                ? maxColumns
                : GridUtils_1.itemsPerRowWidth(width, minColumnWidth, maxColumns, columnGap);
            var gridTemplateColumns = isFullWidth
                ? ''
                : "repeat(" + itemsPerRow + ", minmax(" + itemMinWidth + ", " + itemMaxWidth + "))";
            var gridId = GridUtils_1.generateKey();
            var cssStateDivider = Object.keys(Grid_st_css_1.default.$cssStates({ dividers: true }))[0];
            return (React.createElement("div", __assign({}, Grid_st_css_1.default('root', { dividers: showRowDivider, uniformRowHeight: uniformRowHeight }, rest), { id: gridId }),
                React.createElement("style", { dangerouslySetInnerHTML: {
                        __html: GridUtils_1.getGridStyle({
                            rowGap: rowGap,
                            dividerWidth: dividerWidth,
                            cssStateDivider: cssStateDivider,
                            gridId: gridId,
                            gridTemplateColumns: gridTemplateColumns,
                            listWrapperClass: Grid_st_css_1.default.listWrapper,
                        }) + "\n                  " + (isFullWidth
                            ? GridUtils_1.getMediaQueries({
                                maxColumns: maxColumns,
                                minColumnWidth: minColumnWidth,
                                maxColumnWidth: itemMaxWidth,
                                columnGap: columnGap,
                                ListItemClass: Grid_st_css_1.default.listWrapper,
                                gridId: gridId,
                            })
                            : ''),
                    } }),
                React.createElement("ul", __assign({ className: Grid_st_css_1.default.listWrapper, style: {
                        gridTemplateColumns: gridTemplateColumns,
                        gap: rowGapInPixels + " " + columnGapInPixels,
                    } }, _this.getContainerDataAttributes({
                    itemMaxWidth: itemMaxWidth,
                    itemsPerRow: itemsPerRow,
                    dividerWidth: dividerWidth,
                    rowGapInPixels: rowGapInPixels,
                    columnGapInPixels: columnGapInPixels,
                    maxColumnWidth: itemMaxWidth,
                    minColumnWidth: itemMinWidth,
                }), { "data-hook": DataHooks_1.GridDataHooks.container }), children)));
        }));
    };
    Grid.contextType = TPAComponentsConfig_1.TPAComponentsContext;
    Grid.displayName = 'Grid';
    Grid.Item = Item_1.Item;
    Grid.defaultProps = {
        children: [],
        showRowDivider: false,
        maxColumns: 1,
        width: 0,
        dividerWidth: '1px',
        uniformRowHeight: true,
        minColumnWidth: constants_1.DEFAULT_MIN_WIDTH,
    };
    return Grid;
}(React.PureComponent));
exports.Grid = Grid;
//# sourceMappingURL=Grid.js.map